import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './InvoicesEmpty.module.scss';

interface InvoicesEmptyProps {
    className?: string;
}

export const InvoicesEmpty: FunctionComponent<InvoicesEmptyProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div className={styles.body}>
                <h2 className={styles.title}>No Invoices Yet</h2>
                <p className={styles.description}>You have no registered invoices.</p>
            </div>
            <div className={styles.footer}>
                <p className={styles.poweredBy}>POWERED BY</p>
                <img
                    src="/images/logo/cuddlespay.svg"
                    className={styles.logo}
                    alt="Cuddles Pay"
                />
            </div>
        </div>
    );
};

export default InvoicesEmpty;
